'use client';

import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { LoaderOverlay } from '@/components/ui/loader';
import { useSidebarMenu } from '@/hooks/useSidebarMenu';

export default function HomePage() {
    const router = useRouter();
    const { menu, isLoading } = useSidebarMenu();

    useEffect(() => {
        const firstVisibleItem = menu.find((item) => item.visible !== false);

        if (firstVisibleItem) {
            router.replace(firstVisibleItem.href);
        }
    }, [menu, router]);

    return isLoading ? (
        <LoaderOverlay text="Loading..." className="fixed inset-0 z-100" />
    ) : (
        <></>
    );
}
